import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 26.9 26.9"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "13.4",
      cy: "13.4",
      r: "11.9",
      style: {"opacity":".34","fill":"none","stroke":"#f0c300","stroke-width":"3","stroke-miterlimit":"10"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M13.4 1.5c4.6 0 8.5 2.6 10.5 6.3",
      style: {"fill":"none","stroke":"#f0c300","stroke-width":"3","stroke-linecap":"round","stroke-miterlimit":"10"}
    }, null, -1)
  ]))]))
}
export default { render: render }